/*
A utility class that will run the promise chain but will stop the chain when needed.
*/

type Func = () => void;

export default class CancellablePromiseChain {
    #chain: Promise<unknown>;
    #cancelled: boolean;

    constructor() {
        this.#chain = Promise.resolve();
        this.#cancelled = false;
    }

    then(callback: Func) {
        this.#chain = this.#chain.then(() => {
            return new Promise((resolve, reject) => {
                if (this.#cancelled) {
                    return reject(new Error('cancelled'));
                }
                try {
                    resolve(callback());
                } catch (err) {
                    reject(err);
                }
            });
        });
    }

    /* for testing purposes only */
    get chain() {
        return this.#chain;
    }

    async cancelAndWaitForCurrentTask() {
        this.#cancelled = true;
        try {
            return await this.#chain;
        } catch (err) {
            return err;
        }
    }
}
